export default "__VITE_ASSET__GaVnxhUS__"